export default "__VITE_ASSET__CkxnITUa__"